import { CommonMainPage } from '../../widgets/utility/CommonMainPage'
import { TrademarkInfringementsFilters } from './widgets/trademark-infringements-filters/TrademarkInfringementsFilters'
import { TrademarkInfringementsTable } from './widgets/trademark-infringements-table/TrademarkInfringementsTable'
import { TrademarkInfringementsToolbar } from './widgets/trademark-infringements-toolbar/TrademarkInfringementsToolbar'
import { useAppSelector } from '../../app/store/hooks/Redux'
import { selectTrademarkInfringementsProject } from './model/trademarkInfringementsSlice'
import { TrademarkMissingStub } from '../../lib/widgets/stubs/TrademarkMissingStub'
import { NoActiveTrademarksStub } from './widgets/trademark-infringements-stubs/NoActiveTrademarksStub'
import { NoViolationsStub } from './widgets/trademark-infringements-stubs/NoViolationsStub'
import { StubLayout } from '../../lib/widgets/stubs/StubLayout'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { selectUser } from '../../app/store/reducers/AuthSlice'
import { useTranslation } from 'react-i18next'

export const TrademarkInfringementsPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { tm_infringements_enabled } = useAppSelector(selectUser)
  const {
    value: projectId,
    has_trademarks: hasTrademarks,
    has_active_trademarks: hasActiveTrademarks,
    has_tm_infringements: hasTmInfringements,
  } = useAppSelector(selectTrademarkInfringementsProject)
  const showStub = !hasTrademarks || !hasActiveTrademarks || !hasTmInfringements

  useEffect(() => {
    if (!tm_infringements_enabled) {
      navigate('/projects')
    }
  }, [tm_infringements_enabled])

  return (
    <CommonMainPage
      hint={t('navigation.hint.trademarkInfringements')}
      title={t('navigation.trademarkInfringements')}
    >
      <div className={'flex h-full flex-col gap-[24px]'}>
        <div
          className={`-mx-[16px] border-b-[3px] px-[16px] xl:-mx-[32px] xl:px-[32px] ${showStub ? 'border-transparent' : 'border-[#001c44]/[0.03]'}`}
        >
          <TrademarkInfringementsFilters />
        </div>
        <div className={'flex h-full flex-col gap-[8px]'}>
          {!showStub && <TrademarkInfringementsToolbar />}
          {showStub ? (
            // над заглушкой gap колонки и прозрачный бордер под фильтрами (3px)
            <StubLayout gap={24 + 3}>
              {!hasTrademarks ? (
                <TrademarkMissingStub changeLocation project={projectId} />
              ) : !hasActiveTrademarks ? (
                <NoActiveTrademarksStub project={projectId} />
              ) : (
                <NoViolationsStub />
              )}
            </StubLayout>
          ) : (
            <TrademarkInfringementsTable />
          )}
        </div>
      </div>
    </CommonMainPage>
  )
}
